import { Institution } from './institution.model';

export class Group {
    id:number;
    name:string;
    alias:string;  
    institution:Institution; 
    active:boolean; 
    version:number;
}